import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { Stream } from "./Exports";
export var ChunkedArrayBufferStream = /*#__PURE__*/function (_Stream) {
  _inherits(ChunkedArrayBufferStream, _Stream);

  var _super = _createSuper(ChunkedArrayBufferStream);

  function ChunkedArrayBufferStream(targetChunkSize, streamId) {
    var _this;

    _classCallCheck(this, ChunkedArrayBufferStream);

    _this = _super.call(this, streamId);
    _this.privTargetChunkSize = targetChunkSize;
    _this.privNextBufferReadyBytes = 0;
    return _this;
  }

  _createClass(ChunkedArrayBufferStream, [{
    key: "writeStreamChunk",
    value: function writeStreamChunk(chunk) {
      // No pending write, and the buffer is the right size so write it.
      if (chunk.isEnd || 0 === this.privNextBufferReadyBytes && chunk.buffer.byteLength === this.privTargetChunkSize) {
        _get(_getPrototypeOf(ChunkedArrayBufferStream.prototype), "writeStreamChunk", this).call(this, chunk);

        return;
      }

      var bytesCopiedFromBuffer = 0;

      while (bytesCopiedFromBuffer < chunk.buffer.byteLength) {
        // Fill the next buffer.
        if (undefined === this.privNextBufferToWrite) {
          this.privNextBufferToWrite = new ArrayBuffer(this.privTargetChunkSize);
          this.privNextBufferStartTime = chunk.timeReceived;
        } // Find out how many bytes we can copy into the read buffer.


        var bytesToCopy = Math.min(chunk.buffer.byteLength - bytesCopiedFromBuffer, this.privTargetChunkSize - this.privNextBufferReadyBytes);
        var targetView = new Uint8Array(this.privNextBufferToWrite);
        var sourceView = new Uint8Array(chunk.buffer.slice(bytesCopiedFromBuffer, bytesToCopy + bytesCopiedFromBuffer));
        targetView.set(sourceView, this.privNextBufferReadyBytes);
        this.privNextBufferReadyBytes += bytesToCopy;
        bytesCopiedFromBuffer += bytesToCopy; // Are we ready to write?

        if (this.privNextBufferReadyBytes === this.privTargetChunkSize) {
          _get(_getPrototypeOf(ChunkedArrayBufferStream.prototype), "writeStreamChunk", this).call(this, {
            buffer: this.privNextBufferToWrite,
            isEnd: false,
            timeReceived: this.privNextBufferStartTime
          });

          this.privNextBufferReadyBytes = 0;
          this.privNextBufferToWrite = undefined;
        }
      }
    }
  }, {
    key: "close",
    value: function close() {
      // Send whatever is pending, then close the base class.
      if (0 !== this.privNextBufferReadyBytes && !this.isClosed) {
        _get(_getPrototypeOf(ChunkedArrayBufferStream.prototype), "writeStreamChunk", this).call(this, {
          buffer: this.privNextBufferToWrite.slice(0, this.privNextBufferReadyBytes),
          isEnd: false,
          timeReceived: this.privNextBufferStartTime
        });
      }

      _get(_getPrototypeOf(ChunkedArrayBufferStream.prototype), "close", this).call(this);
    }
  }]);

  return ChunkedArrayBufferStream;
}(Stream);